import { AnimatePresence, motion } from "framer-motion";
import { AlertTriangle, Loader2 } from "lucide-react";

export const ConfirmModal = ({
  open,
  title = "Confirmer",
  message = "",
  confirmLabel = "Supprimer",
  cancelLabel = "Annuler",
  loading = false,
  onConfirm,
  onClose,
}) => (
  <AnimatePresence>
    {open && (
      <div className="fixed inset-0 z-[200] flex items-center justify-center p-5" data-testid="confirm-modal">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          onClick={onClose}
          className="absolute inset-0 bg-ink/80 backdrop-blur-md"
          data-testid="confirm-modal-overlay"
        />
        <motion.div
          initial={{ opacity: 0, y: 14, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 14, scale: 0.98 }}
          transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
          className="relative w-full max-w-sm rounded-3xl border border-white/12 bg-ink shadow-2xl shadow-black/60 p-8"
        >
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-accent-yellow/12 mb-5">
            <AlertTriangle size={22} className="text-accent-yellow" />
          </div>
          <h3 className="font-display text-xl font-medium tracking-tight">{title}</h3>
          {message && <p className="mt-3 text-sm text-white/55 font-light leading-relaxed">{message}</p>}

          <div className="mt-7 flex gap-3">
            <button
              onClick={onClose}
              disabled={loading}
              data-testid="confirm-cancel"
              className="flex-1 px-5 py-3 rounded-xl border border-white/20 text-sm hover:border-white/40 transition-colors disabled:opacity-60"
            >
              {cancelLabel}
            </button>
            <button
              onClick={onConfirm}
              disabled={loading}
              data-testid="confirm-accept"
              className="flex-1 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-red-500 text-white text-sm font-semibold hover:bg-red-400 transition-colors disabled:opacity-60"
            >
              {loading && <Loader2 size={16} className="animate-spin" />}
              {confirmLabel}
            </button>
          </div>
        </motion.div>
      </div>
    )}
  </AnimatePresence>
);
